module.exports = __webpack_public_path__ + "img/btn_google_signin_light_normal_web.3a33ebe2.png";